<template lang="html">
  <div class="pay">
    <div class="banner">
      <img src="../../assets/image/pay/banner_1.jpg" alt="">
    </div>
    <div class="content">
      <!-- 6大亮点 -->
      <div class="lightspot">
        <div class="title">
          <img src="../../assets/image/pay/title_1.png" alt="">
        </div>
        <div class="lightspotCon">
          <div class="details">
            <img src="../../assets/image/pay/light_1.png" alt="">
          </div>
          <div class="details">
            <img src="../../assets/image/pay/light_2.png" alt="">
          </div>
          <div class="details">
            <img src="../../assets/image/pay/light_3.png" alt="">
          </div>
          <div class="details">
            <img src="../../assets/image/pay/light_4.png" alt="">
          </div>
          <div class="details">
            <img src="../../assets/image/pay/light_5.png" alt="">
          </div>
          <div class="details">
            <img src="../../assets/image/pay/light_6.png" alt="">
          </div>
        </div>
      </div>

      <!-- 7天学习内容 -->
      <div class="learn">
        <div class="title">
          <img src="../../assets/image/pay/title_2.png" alt="">
        </div>
        <div class="learnCon" v-bind:class="{'showAll': show}">
          <div class="learnTop">
            <div class="learnDetails">
              <div class="learnDetailsLeft">
                <img src="../../assets/image/pay/icon_1.png" alt="" class="icon1">
                <img src="../../assets/image/pay/icon_2.png" alt="" class="icon2">
              </div>
              <div class="learnDetailsRight">
                <div>DAY：1</div>
                <p>实战项目概述和研发环境搭建</p>
                <ul>
                  <li><span></span>如何做好一件硬件设计工作</li>
                  <li><span></span>NB-IoT物联网及项目开发实训课程简介</li>
                  <li><span></span>硬件设计环境搭建及系统设置</li>
                </ul>
              </div>
            </div>
            <div class="learnDetails">
              <div class="learnDetailsLeft">
                <img src="../../assets/image/pay/icon_1.png" alt="" class="icon1">
                <img src="../../assets/image/pay/icon_2.png" alt="" class="icon2">
              </div>
              <div class="learnDetailsRight">
                <div>DAY：2</div>
                <p>项目开发需求分析</p>
                <ul>
                  <li><span></span>观看《项目开发过程》各阶段主要活动相关视频</li>
                  <li><span></span>完成项目计划书和项目规格书</li>
                  <li><span></span>输出总体设计方案</li>
                </ul>
              </div>
            </div>
            <div class="learnDetails">
              <div class="learnDetailsLeft">
                <img src="../../assets/image/pay/icon_1.png" alt="" class="icon1">
                <img src="../../assets/image/pay/icon_2.png" alt="" class="icon2">
              </div>
              <div class="learnDetailsRight">
                <div>DAY：3</div>
                <p>实战项目原理图设计</p>
                <ul>
                  <li><span></span>观看《项目开发过程》详细设计阶段主要活动及软件概述相关视频</li>
                  <li><span></span>创建原理图符号库</li>
                </ul>
              </div>
            </div>
          </div>

          <div class="">
            <div class="learnDetails day" v-bind:class="{'showDay': show_day}">
              <div class="learnDetailsLeft">
                <img src="../../assets/image/pay/icon_1.png" alt="" class="icon1">
                <img src="../../assets/image/pay/icon_2.png" alt="" class="icon2">
              </div>
              <div class="learnDetailsRight">
                <div>DAY：4</div>
                <p>实战项目原理图绘制及文件交付</p>
                <ul>
                  <li><span></span>观看软件实操及文件输出相关视频</li>
                  <li><span></span>实战项目原理图绘制</li>
                  <li><span></span>输出原理图BOM和设计报告</li>
                </ul>
              </div>
            </div>
            <div class="learnDetails day" v-bind:class="{'showDay': show_day}">
              <div class="learnDetailsLeft">
                <img src="../../assets/image/pay/icon_1.png" alt="" class="icon1">
                <img src="../../assets/image/pay/icon_2.png" alt="" class="icon2">
              </div>
              <div class="learnDetailsRight">
                <div>DAY：5</div>
                <p>实战项目pcb设计文件交付</p>
                <ul>
                  <li><span></span>观看《PCB设计基础》及软件使用相关视频</li>
                  <li><span></span>输出设计报告</li>
                  <li><span></span>输出PCB交付文件</li>
                </ul>
              </div>
            </div>
            <div class="learnDetails day" v-bind:class="{'showDay': show_day}">
              <div class="learnDetailsLeft">
                <img src="../../assets/image/pay/icon_1.png" alt="" class="icon1">
                <img src="../../assets/image/pay/icon_2.png" alt="" class="icon2">
              </div>
              <div class="learnDetailsRight">
                <div>DAY：6</div>
                <p>单板调测</p>
                <ul>
                  <li><span></span>观看《项目开发过程》调测阶段主要活动及《常用仪器使用》相关视频</li>
                  <li><span></span>输出单板硬件调试及单元测试方案</li>
                  <li><span></span>输出单板硬件调试及单元测试报告</li>
                </ul>
              </div>
            </div>
            <div class="learnDetails day" v-bind:class="{'showDay': show_day}">
              <div class="learnDetailsLeft">
                <img src="../../assets/image/pay/icon_1.png" alt="" class="icon1">
                <img src="../../assets/image/pay/icon_2.png" alt="" class="icon2" style="height:20px">
              </div>
              <div class="learnDetailsRight">
                <div>DAY：7</div>
                <p>直播答疑※进阶指导※作业诊断</p>
              </div>
            </div>
          </div>
          <!-- <div class="show_btn" v-show="show_btn" @click="showBtn"><p>更多</p><img src="../../assets/image/pay/else.png" alt="" class="allicon"></div> -->
        </div>
      </div>

      <!-- 使用人群 -->
      <div class="crowd">
        <div class="title">
          <img src="../../assets/image/pay/title_3.png" alt="">
        </div>
        <div class="crowdCon">
          <img src="../../assets/image/pay/crowd.png" alt="">
        </div>
      </div>

      <!-- 3大平台 2大专家团队护航 -->
      <div class="terrace">
        <div class="title2">
          <img src="../../assets/image/pay/title_4.png" alt="">
        </div>
        <div class="terraceCon">
          <img src="../../assets/image/pay/terrace.png" alt="">
        </div>
      </div>

      <!-- 体验流程 -->
      <div class="flow">
        <div class="title">
          <img src="../../assets/image/pay/title_5.png" alt="">
        </div>
        <div class="flowCon">
          <div class="flowTop">
            <div class="">
              <img src="../../assets/image/pay/flow_1.png" alt="" class="icon_3">
              <p>体验营</p>
              <p>支付成功</p>
            </div>
            <p>
              <img src="../../assets/image/pay/next.png" alt="" class="next">
            </p>
            <div class="">
              <img src="../../assets/image/pay/flow_1.png" alt="" class="icon_3">
              <p>识别二维码</p>
              <p>添加助理</p>
            </div>
            <p>
              <img src="../../assets/image/pay/next.png" alt="" class="next">
            </p>
            <div class="">
              <img src="../../assets/image/pay/flow_1.png" alt="" class="icon_3">
              <p>获取体验营</p>
              <p>服务</p>
            </div>
            <p>
              <img src="../../assets/image/pay/next.png" alt="" class="next">
            </p>
            <div class="">
              <img src="../../assets/image/pay/flow_1.png" alt="" class="icon_3">
              <p>等待体验营</p>
              <p>开启特训</p>
            </div>
          </div>
          <div class="flowCenter">
            <img src="../../assets/image/pay/hint.png" alt="">
          </div>
          <div class="flowBottom">
            为保证您的学习效果，请务必添加助理微信邀您进入体验营班级进行学习，否则无法进行进营学习，助理会3小时内通过，由工作人员为你安排入营。
          </div>
        </div>
      </div>

      <!-- 你的收获 -->
      <div class="harvest">
        <div class="title">
          <img src="../../assets/image/pay/title_6.png" alt="">
        </div>
        <div class="harvestCon">
          <img src="../../assets/image/pay/harvest_1.png" alt="">
          <img src="../../assets/image/pay/harvest_2.png" alt="" class="harvestImg">
          <img src="../../assets/image/pay/harvest_3.png" alt="" class="harvestImg">
          <img src="../../assets/image/pay/harvest_4.png" alt="" class="harvestImg">
        </div>
      </div>

      <!-- 关于EMEA特战营 -->
      <div class="emea">
        <div class="title">
          <img src="../../assets/image/pay/title_7.png" alt="">
        </div>
        <div class="emeaCon">
          电巢EMEA特战营通过高标准和完整的创新模式，打造电子行业的工程师铁军。
          这里凝聚善于学习、乐于分享、积极进取的个人，实现个人研发能力的持续提升，
          帮助每一位队员实现自身的价值，助力每位队员从平凡到优秀的加速蜕变。
        </div>
      </div>

      <!-- 按钮 -->
      <div class="btn" @click="signUp">
        <p class="money">￥ 8.00</p>
        <p>立即报名</p>
      </div>
      <div class="explain">
        说明：由于知识付费产品特殊性，体验营开营后不予退款
      </div>
    </div>
  </div>
</template>

<script>
import {pagebase} from '@/utils/http.js';
import utils from '@/utils/utils';
import WxShare from '@/utils/wxshare';

// 百度
var _hmt = _hmt || [];
(function(){
  var hm = document.createElement("script");
  hm.src  =  "https://hm.baidu.com/hm.js?24b8cea1e8cafdb512e2f597cf3fa8df";
  var s = document.getElementsByTagName("script")[0];
  s.parentNode.insertBefore(hm, s);
})();

// 头条
(function(r,d,s){
  r._tt_config = true;
  var _baq = (r._baq=r._baq||[]);
  _baq.methods=["track","off","on"];
  _baq.factory=function(method){
    return function(){
      var args=Array.prototype.slice.call(arguments);
      args.unshift(method);
      _baq.push(args);
      return _baq
    }
  };
  for(var i=0;i<_baq.methods.length;i++){
    var key=_baq.methods[i];
    _baq[key]=_baq.factory(key)
  }
  _baq.load=function(){
    var js,fjs=d.getElementsByTagName(s)[0];
    js=d.createElement(s);
    js.src="https://analytics.oceanengine.com/api/v2/js/sdk";
    fjs.parentNode.insertBefore(js,fjs)
  };
  _baq.load();
  if(_baq.invoked){
    return
  }
  _baq.invoked=true;
  _baq.track("pageview")
})(window,document,"script");

var activity_id;
var env = process.env.NODE_ENV;
if(env == 'development' || env == undefined){
  activity_id = 93
}else if(env == 'production'){
  activity_id = 200
}

export default {
  data(){
    return{
      show: false,
      show_day: false,
      show_btn: true,
      pagebase: pagebase,
    }
  },
  mounted(){
    this.info();
  },
  methods:{
    info(){
      this.wxshare = new WxShare();
      this.showStat();
    },
    showStat(){
      this.$http({
        url: '/api/showStat',
        method: 'post',
        params: {
          url: window.location.href,
        }
      }).then(res => {
        if(res.code >= 0){
          this.wxshare.share({
            title: '零经验7天入门硬件设计',
            desc: '电子产业链一站式数字化服务平台，电子人学习、工作、认证的孵化巢',
            link: window.location.href,
            imgUrl: '../../assets/image/pay/banner_1.jpg',
          })
        }
      })
    },
    showBtn(){
      this.show = true;
      this.show_day = true;
      this.show_btn = false;
    },
    signUp(){
      var succeedUrl = encodeURIComponent(pagebase + '/#/paySucceed?activity_id=' + activity_id);
      if(utils.browserChecker.isWx()){
        var channel = this.$route.query.channel || '';
        var open = encodeURIComponent(pagebase + '/#/payment?activity_id='+ activity_id + '&project=emea' + '&channel=' + channel + '&succeed_url=' + succeedUrl);
        var url = 'http://edu.eda365.com/wechat_redirect.php?jump_url=' + open;
        window.location.href = url;
      }else{
        this.$router.push({
          path:'/payment',
          query:{
            activity_id : activity_id,
            channel : this.$route.query.channel || '',
            project: 'emea',
            track_id: this.$route.query.track_id || '',
            succeed_url: succeedUrl,
          }
        })
      }
    },
  },
}
</script>

<style lang="css" scoped>
.pay{
  background-color: #092855;
}
.banner{
  width: 100%;
}
.banner img{
  width: 100%;
  object-fit: cover;
}
.content{
  background-color: #092855;
  box-sizing: border-box;
  padding: 0 15px;
  padding-bottom: 70px;
}
.lightspot{
  padding-top: 26px;
}
.title{

}
.title img{
  height: 46px;
}
.title2 img{
  height: 80px;
}
.lightspotCon{
  margin-top: 20px;
  box-sizing: border-box;
  border-radius: 10px;
  padding: 8px;
  background-color: #E1EFFF;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.details{
  width: 48%;

}
.details img{
  width: 100%;
}

.learn{
  padding-top: 22px;
}
.learnCon{
  overflow: hidden;
  /* height: 570px; */
  margin-top: 20px;
  box-sizing: border-box;
  border-radius: 10px;
  padding: 0 8px;
  padding-bottom: 10px;
  background-color: #E1EFFF;
}
.earnTop{

}

.learnDetails{
  display: flex;
  margin: 10px 0;
}
/* .day{
visibility: hidden;
}
.showDay{
display: block;
} */
.showAll{
  height: 100%;
}
.learnDetailsLeft{
  display: flex;
  flex-direction: column;
  align-items: center;
}
.icon1{
  width: 16px;
}
.icon2{
  width: 1px;
  height: 80%;
}
.learnDetailsRight{
  color: #072753;
  margin-left: 10px;
}
.learnDetailsRight div{
  font-size: 20px;
}
.learnDetailsRight p{
  font-size: 16px;
}
.learnDetailsRight ul{
  margin-top: 5px;
}
.learnDetailsRight li{
  margin-top: 5px;
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #FE6205;
}
.learnDetailsRight span{
  border-radius: 5px;
  width: 5px;
  height: 5px;
  background-color: #FE6205;
  margin-right: 5px;
}
.show_btn{
  margin-top: 25px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #056AFE;
  font-size: 16px;
}
.allicon{
  margin-top: 5px;
  margin-left: 10px;
  width: 10px;
  height:
}

.crowd{
  padding-top: 22px;
}
.crowdCon{
  margin-top: 20px;
  box-sizing: border-box;
  border-radius: 10px;
  padding: 20px 8px;
  background-color: #E1EFFF;
}
.crowdCon img{
  width: 100%;
  height: 100%;
}

.terrace{
  padding-top: 22px;
}
.terraceCon{
  margin-top: 20px;
  box-sizing: border-box;
  border-radius: 10px;
  padding: 20px 8px;
  background-color: #E1EFFF;
}
.terraceCon img{
  width: 100%;
  height: 100%;
}

.flow{
  padding-top: 22px;
}
.flowCon{
  margin-top: 20px;
  box-sizing: border-box;
  border-radius: 10px;
  padding: 20px 8px;
  background-color: #E1EFFF;
}
.flowTop{
  display: flex;
  justify-content: space-between;
}
.flowTop div{
  font-size: 12px;
  color: #092855;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.icon_3{
  width: 65px;
}
.next{
  width: 12px;
  margin-top: 30px;
}
.flowCenter{
  margin-top: 20px;
}
.flowCenter img{
  width: 100%;
}
.flowBottom{
  padding: 0 5px;
  font-size: 12px;
  color: #F75D06;
}

.harvest{
  padding-top: 22px;
}
.harvestCon{
  margin-top: 20px;
  box-sizing: border-box;
  border-radius: 10px;
  padding: 0 8px;
  background-color: #E1EFFF;
}
.harvestCon img{
  width: 100%;
  margin-left: -8px;
}
.harvestImg{
  margin-top: -20px;
}

.emea{
  padding-top: 22px;
}
.emeaCon{
  font-size: 13px;
  margin-top: 20px;
  box-sizing: border-box;
  border-radius: 10px;
  padding: 13px 18px;
  background-color: #E1EFFF;
}

.btn{
  font-size: 20px;
  position: fixed;
  bottom: 15px;
  left: 50%;
  margin-left: -170px;
  display: flex;
  justify-content: center;
  margin-top: 20px;
  width: 340px;
  height: 45px;
  line-height: 45px;
  text-align: center;
  border-radius: 40px;
  background: linear-gradient(#ffcc01 , #ffa201);
  color: #FFF;
}
.money{
  margin-right: 30px;
}
.explain{
  margin-top: 10px;
  color: #21E3FF;
  font-size: 12px;
  text-align: center;
}
</style>
